import { sortCaret } from "../../../comum/components/Icones";
import ConsultaDepotTriagemController from "../../../../services/ConsultaDepotTriagemController";
import { observable } from "mobx";
import { formatarDataCustomHTML } from '../../../../utils/formatar';
import {formatarDataCustomHTMLSemHora, numericSortFunc, dataSortFunc, situacaoFormatter, splitQuebraLinha} from '../../../../utils/formatar';
import { getMesTexto } from "../../../../utils/functions";


export default class TriagemDepotStore {
    
    @observable veiculos;
    @observable loadingVeiculos;
    @observable isMobile;
    @observable filtro;
    @observable avisoOn;
    @observable searchModalON;
    @observable modalDados;
    @observable  msg;
    constructor() {
        this.filtro = "";
        this.msg = "";
        this.veiculos = [];
        this.searchModalON = false;
        this.modalDados = false;
        this.loadingVeiculos = false;
        this.avisoOn = false;
        this.isMobile = false;
        this.service = new ConsultaDepotTriagemController();
        this.itensOrdemInicial()
    }
    
    mockItens = () => {
        console.log('montou');
        this.veiculos = [{
            DscTipo: "Item 1",
            Data: "25/07/2023",
            Hora: "7",
            Placa: "qqq1234",
            Armador: "MAERSK LINE",
            Booking: "45676545649",
            Container: "adqdqwdqwdq",
            Situacao: "AGENDADO",
        },
        {
            DscTipo: "Item 2",
            Data: "25/07/2023",
            Hora: "7",
            Placa: "qqq1234",
            Armador: "MAERSK LINE",
            Booking: "45676545649",
            Container: "adqdqwdqwdq",
            Situacao: "AGENDADO",
        }]
    }

listar = async () => {
        console.log('entrous')
    if (this.filtro.length > 0) {
        
        if (this.isMobile) {
            this.loadingVeiculos = true;
            await this.service.listarFiltro(this.filtro).then(res => {
                if (res.data) {
                    console.log(res.data)
                    this.veiculos = res.data;
                    // this.searchModalON = true;
                    console.log('veicle', this.veiculos)

                    this.loadingVeiculos = false;

                } else {
                    this.veiculos = [];
                    this.msg = "Nenhum registro encontrado!"
                    this.avisoOn = true;
                }
             })
        } else {
            this.loadingVeiculos = true;
            await this.service.listarFiltro(this.filtro).then(res => {
                if (res.data) {
                    this.veiculos = res.data;
                    console.log(this.veiculos)
                } else {
                    this.veiculos = [];
                    this.msg = "Nenhum registro encontrado!"
                    this.avisoOn = true;
                }
            }).catch(err => console.error(err)
            ).finally(() => this.loadingVeiculos = false);
        }
    } else {
        this.itensOrdemInicial()
    }
 }

    adicionarFiltro = (valor) => {
        this.filtro = valor;
        console.log(this.filtro)
    };


    listarVeiculos = () => {
        this.itensOrdemInicial();
    }

    itensOrdemInicial = async () => {
        this.loadingVeiculos = true;
        this.veiculos = []
        await this.service.ListarItensOrdem().then(res => {
            console.log('data', res.data)
            if(res.data.length > 0) {
                this.veiculos = res.data;
                console.log(this.veiculos)
                this.loadingVeiculos = false;
            } else {
                this.loadingVeiculos = false;
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingVeiculos = false);

        console.log(this.loadingVeiculos)
    }

    colunas =
    [{
        dataField: 'DscTipo',
        text: 'Tipo',
        headerStyle: () => {
            return { width: "200px" };
        },
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'Data',
        text: 'Data',
        formatter: formatarDataCustomHTMLSemHora,      
        sort: true,
        sortCaret: sortCaret,
        sortFunc : dataSortFunc
    },{
        dataField: 'Hora',                                                                                                                                                                                                                                                                                                                                                  
        text: 'Hora',
        sort: true,
        sortCaret: sortCaret,
        sortFunc : numericSortFunc
    },{
        dataField: 'Placa',
        text: 'Placa',
        sort: true,
        sortCaret: sortCaret,
    },/*{
        dataField: 'PlacaCarret1',
        text: 'Placa Carreta',
        sort: true,
        sortCaret: sortCaret,
    },{
        dataField: 'PlacaCarret2',
        text: 'Placa Carreta 2',
        sort: true,
        sortCaret: sortCaret,
    }*/{
        dataField: 'Carretas',
        text: 'Carretas',
        headerStyle: () => {
            return { width: "50px" };
        },
        sort: true,
        sortCaret: sortCaret,
    },{
        dataField: 'Cnh',
        text: 'CNH',
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'ApelidoArmador',
        text: 'Arm.',
        sort: true,
        sortCaret: sortCaret,
        hidden: process.env.ssa ? false : true,
        formatter: (cell) => cell === null ? '---' : cell
    }, {
        dataField: 'NumBooking',
        text: 'Booking',
        sort: true,
        sortCaret: sortCaret,
        hidden: process.env.ssa ? false : true,
        formatter: (cell) => cell === null ? '---' : cell
    }, {
        dataField: 'LstCntrs',
        text: 'Cntr(s)',
        headerStyle: () => {
            return { width: "110px" };
        },
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'ApelidoTransp',
        text: 'Transp.',
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'UsuarioIncl',
        text: 'Usuário',
        headerStyle: () => {
            return { maxWidth: "60px" };
        },
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'StatusAgendamento',
        text: 'Situação',
        headerStyle: () => {
            return { maxWidth: "60px" };
        },
        formatter: situacaoFormatter,
        sort: true,
        sortCaret: sortCaret,
    }]

        // [
    //     {
    //         dataField: 'VclPlacaVeiculo',
    //         text: 'Tipo',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cnh',
    //         text: 'Data',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Nome',
    //         text: 'Hora',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cntrs',
    //         text: 'Placa',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cntrs',
    //         text: 'Armador',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cntrs',
    //         text: 'Booking',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cntrs',
    //         text: 'Container',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     },
    //     {
    //         dataField: 'Cntrs',
    //         text: 'Situação',
    //         sort: true,
    //         sortCaret: sortCaret,
    //         headerAlign: () => 'left'
    //     }
    // ]

}



// WEBPACK FOOTER //
// ./src/modules/consultas/triagem-depot/stores/TriagemDepotStore.js